import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PaymentMethodDetail } from 'app/model/booking/my-booking-model-v2';
import { PaymentChannelType, PaymentChannelStatus, RefundType, PaymentMethodDetailType, PaymentStatus, BookingStatusType } from '../../model/constant';

@Component({
  selector: 'act-payment-method-details',
  templateUrl: './payment-method-details.component.html',
  styleUrls: ['./payment-method-details.component.scss']
})
export class PaymentMethodDetailsComponent implements OnInit {

  @Input() paymentChannel: PaymentChannelType;
  @Input() displayCancelButton: boolean;
  @Input() payOnDate: string;
  @Input() isCancelled: boolean;
  @Input() refundType: RefundType;
  @Input() prefixElementId: string;
  @Input() paymentMethodDetail: PaymentMethodDetail;
  @Input() isCancelBeforePayCreditCard: boolean = false;
  @Input() paymentMethodDisplay: string;
  @Input() bookingStatus: string;

  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  public hidePaymentDateSection: boolean;
  public cancellationPolicy: string = null;
  public cancellationPolicyTitle: string = null;
  public anotherCancellationPolicy: string = null;
  public anotherCancellationPolicyTitle: string = null;
  public PaymentChannelType = PaymentChannelType;
  public PaymentMethodDetailType = PaymentMethodDetailType;
  public RefundType = RefundType;
  public PaymentStatus = PaymentStatus;
  public BookingStatusType = BookingStatusType;

  constructor() { }

  ngOnInit() {
    this.setHideDateSection();
    this.setCancellationPolicy();
  }

  onClickCancel() {
    this.onCancel.emit();
  }

  setHideDateSection() {
    this.hidePaymentDateSection = false;
    if (this.isCancelled) {
      switch (this.paymentChannel) {
        case PaymentChannelType.TRUE_MONEY:
        case PaymentChannelType.CORPORATE_FLEET:
        case PaymentChannelType.PERSONAL_FLEET:
        case PaymentChannelType.QR_CODE:
        case PaymentChannelType.E_WALLET:
        case PaymentChannelType.IM_BANKING:
        case PaymentChannelType.PAY_AT_COUNTER:
          this.hidePaymentDateSection = this.refundType === RefundType.PARTIAL_REFUND || this.refundType === RefundType.FULL_REFUND;
          break;
        case PaymentChannelType.CREDIT_CARD:
          this.hidePaymentDateSection = this.refundType === RefundType.PARTIAL_REFUND || (this.refundType === RefundType.FULL_REFUND && !this.isCancelBeforePayCreditCard);
        default:
          break;
      }
    }
  }

  setCancellationPolicy() {
    if (this.isCancelled) {
      if (this.refundType === RefundType.PARTIAL_REFUND || this.refundType === RefundType.FULL_REFUND) {
        // refund policy - main payment
        if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.CREDIT_CARD) {
          this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-credit-card';
          if (this.paymentMethodDetail.anotherPaymentMethod) {
            this.cancellationPolicyTitle = 'payment-method-detail-payment-credit-terms';
          }
        } else if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.CORPORATE_FLEET) {
          this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
          if (this.paymentMethodDetail.anotherPaymentMethod) {
            this.cancellationPolicyTitle = 'payment-method-detail-payment-corporate-fleet';
          }
        } else if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.PERSONAL_FLEET) {
          this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
          if (this.paymentMethodDetail.anotherPaymentMethod) {
            this.cancellationPolicyTitle = 'payment-method-detail-payment-personal-fleet';
          }
        } else if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.TRUE_MONEY) {
          this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-true-money';
          if (this.paymentMethodDetail.anotherPaymentMethod) {
            this.cancellationPolicyTitle = 'payment-method-detail-payment-true-money';
          }
        } else if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.QR_CODE ||
                   this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.IM_BANKING ||
                   this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.PAY_AT_COUNTER) {
          this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-payment';
          if (this.paymentMethodDetail.anotherPaymentMethod) {
            this.cancellationPolicyTitle = this.paymentMethodDetail.anotherPaymentMethodDisplay;
          }
        } else if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.E_WALLET) {
          this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-e-wallet';
          if (this.paymentMethodDetail.anotherPaymentMethod) {
            this.cancellationPolicyTitle = this.paymentMethodDetail.anotherPaymentMethodDisplay;
          }
        }
        // refund policy - another payment
        if (this.paymentMethodDetail.anotherPaymentMethod === PaymentMethodDetailType.CREDIT_CARD) {
          if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS) {
            this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-credit-card';
          } else {
            this.anotherCancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-credit-card';
            this.anotherCancellationPolicyTitle = 'payment-method-detail-payment-credit-card';
          }
        } else if (this.paymentMethodDetail.anotherPaymentMethod === PaymentMethodDetailType.TRUE_MONEY) {
          if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS) {
            this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-true-money';
          } else {
            this.anotherCancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-true-money';
            this.anotherCancellationPolicyTitle = 'payment-method-detail-payment-true-money';
          }
        } else if (this.paymentMethodDetail.anotherPaymentMethod === PaymentMethodDetailType.PERSONAL_FLEET) {
          if (this.paymentMethodDetail.mainPaymentMethod === PaymentMethodDetailType.CREDIT_TERMS) {
            this.cancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
          } else {
            this.anotherCancellationPolicy = 'payment-method-detail-payment-date-refund-policy-details-fleet';
            this.anotherCancellationPolicyTitle = 'payment-method-detail-payment-personal-fleet';
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/payment-method-details/payment-method-details.component.ts